// extracted by mini-css-extract-plugin
export default {"unverifiedWrapper":"Unverified_unverifiedWrapper__YEK2q"};